module.exports = __webpack_public_path__ + "media/images/site/64x64-25c9941f6d7852dfdfbc710dea9476f4.png";